<ignite-card id="team-dashboard-header">
  <div card-title i18n>You're all set. Control your teams from here.</div>
  <div card-content i18n>Add team members, create locations and find helpful hints.</div>
</ignite-card>
<div>
  <mat-label class="ignite-label">Tabs style</mat-label>
  <mat-radio-group class="horizontal-layout" [(ngModel)]="tabStyleSelected">
    @for (s of tabStyles; track s) {
    <mat-radio-button [value]="s.value">
      {{ s.viewValue }}
    </mat-radio-button>
    }
  </mat-radio-group>
</div>
<mat-tab-group animationDuration="0ms" (selectedTabChange)="onTabChange($event)">
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="label-text" [class.menu-style]="tabStyleSelected === '1'">Controls</span>
    </ng-template>
    <span ignitetooltip="Resend welcome email">Tooltip</span>
    <br />
    <br />
    <mat-slide-toggle ignite-toggle>Toggle</mat-slide-toggle>
    <br />
    <br />
    <mat-button-toggle-group
      name="toggle"
      aria-label="Toggle options"
      [hideSingleSelectionIndicator]="true"
      [value]="'en'"
    >
      <mat-button-toggle value="en">English</mat-button-toggle>
      <mat-button-toggle value="ko">Korean</mat-button-toggle>
    </mat-button-toggle-group>
    <br />
    <br />
    <div>
      <a (click)="openTemplateSheetMenu()">Bottom sheet 1</a>
    </div>
    <div>
      <a (click)="openTemplateSheetMenu(2)">Bottom sheet 2</a>
    </div>
    <br />
    <div>Progress bar</div>
    <mat-progress-bar ignite-progress-bar mode="determinate" value="40"></mat-progress-bar>
    <br />
    <div>Progress spinner</div>
    <mat-progress-spinner ignite-progress-spinner class="example-margin" color="primary" mode="determinate" [value]="progressValue">
    </mat-progress-spinner>
    <br />
    <div class="ignite-buttons-container" style="width: 300px">
      <button class="ignite-button" (click)="showSnackbar('success')" mat-button>Show success snackbar</button>
      <button class="ignite-button" (click)="showSnackbar('alert')" mat-button>Show alert snackbar</button>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="label-text" [class.menu-style]="tabStyleSelected === '1'">Stepper</span>
    </ng-template>
    <br />
    <app-stepper></app-stepper>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="label-text" [class.menu-style]="tabStyleSelected === '1'">Side Menu</span>
    </ng-template>
    <br />
    <app-menu></app-menu>
  </mat-tab>
</mat-tab-group>

<ng-template let-bottomSheetRef="bottomSheetRef" #templateBottomSheet>
  <div class="bottom-sheet">
    <img src="/assets/images/Goal.png" />
    <div class="title">Why do we need this information?</div>
    <ul>
      <li>To make sure we understand your study goals</li>
      <li>To calculate where you at now and the score goals you want to reach</li>
    </ul>
  </div>
</ng-template>

<ng-template let-bottomSheetRef="bottomSheetRef" #templateBottomSheet2>
  <div class="bottom-sheet">
    <img src="/assets/images/Focus.png" />
    <div>Do you feel you need to improve most in speaking, reading, writing or listening?</div>
  </div>
</ng-template>
<br /><br />
